export const ptBR = {
  // Nav
  'nav.dashboard': 'Painel',
  'nav.animals': 'Animais',
  'nav.lots': 'Lotes',
  'nav.events': 'Eventos',
  'nav.movements': 'Movimentações',
  'nav.movements.short': 'Movim.',
  'nav.reproduction': 'Reprodução',
  'nav.reproduction.short': 'Repro.',
  'nav.indicators': 'Indicadores',
  'nav.indicators.short': 'Zootec.',
  'nav.dairy': 'Controle Leiteiro',
  'nav.dairy.short': 'Leite',
  'nav.sales': 'Vendas',
  'nav.sync_conflicts': 'Conflitos sync',
  'nav.sync_conflicts.short': 'Conflitos',
  'nav.admin': 'Administração',
  'nav.expand': 'Expandir menu lateral',
  'nav.collapse': 'Recolher menu lateral',
  'nav.brand.tagline': 'Gestão de rebanho',
  'nav.footer': 'Sistema Manejai',

  // Domain — sex / events / movements
  'sex.male': 'Macho',
  'sex.female': 'Fêmea',
  'event.weighing': 'Pesagem',
  'event.weaning': 'Desmame',
  'event.natural_mount': 'Monta natural',
  'event.insemination': 'Inseminação',
  'event.pregnancy_diagnosis': 'Diagnóstico gestação',
  'event.birth': 'Parto',
  'event.milk_weighing': 'Pesagem de leite',
  'event.medication': 'Medicação / Vacinação',
  'event.milestone': 'Marco',
  'movement.transfer': 'Transferência',
  'movement.sale': 'Venda',
  'movement.death': 'Morte',

  // Event detail labels
  'event.detail.weight': 'Peso',
  'event.detail.weaning_weight': 'Peso desmame',
  'event.detail.production': 'Produção',
  'event.detail.drying_off': 'Secagem',
  'event.detail.bull': 'Touro',
  'event.detail.dose': 'Dose',
  'event.detail.route': 'Via',
  'event.detail.product_batch': 'Lote frasco',
  'event.detail.next_dose': 'Próxima dose',
  'common.yes': 'Sim',
  'common.dash': '—',

  // Settings
  'settings.title': 'Minha conta',
  'settings.subtitle': 'Perfil, idioma, formatos e dados da conta',
  'settings.tab.profile': 'Perfil',
  'settings.tab.locale': 'Idioma e região',
  'settings.tab.notifications': 'Notificações',
  'settings.tab.password': 'Senha',
  'settings.tab.client': 'Dados da conta',
  'settings.locale.title': 'Idioma e região',
  'settings.locale.language': 'Idioma da interface',
  'settings.locale.language_hint':
    'Ao salvar, o menu e os textos ligados ao idioma mudam automaticamente.',
  'settings.locale.formats_title': 'Formatos da conta',
  'settings.locale.formats_hint':
    'Valem para todos os usuários desta conta. API e banco continuam em kg e datas ISO.',
  'settings.locale.country': 'País / região',
  'settings.locale.currency': 'Moeda',
  'settings.locale.weight_unit': 'Unidade de peso',
  'settings.locale.date_format': 'Formato de data',
  'settings.locale.time_format': 'Formato de hora',
  'settings.locale.timezone': 'Fuso horário',
  'settings.locale.formats_readonly':
    'Somente owner/manager pode alterar formatos da conta. Você pode mudar o idioma da interface.',
  'settings.locale.saved': 'Preferências atualizadas.',
  'settings.locale.language_saved': 'Idioma atualizado.',
  'settings.locale.save_error': 'Erro ao salvar.',
  'settings.locale.save': 'Salvar preferências',
  'settings.locale.save_language': 'Salvar idioma',

  // Weight / date option labels (settings selects)
  'locale.weight.kg': 'Quilograma (kg)',
  'locale.weight.lb': 'Libra (lb)',
  'locale.date.dmy': 'Dia / Mês / Ano',
  'locale.date.mdy': 'Mês / Dia / Ano',
  'locale.date.ymd': 'Ano - Mês - Dia',
  'locale.time.h24': '24 horas',
  'locale.time.h12': '12 horas (AM/PM)',

  'calendar.open': 'Abrir calendário',
  'calendar.clear': 'Limpar',
  'calendar.today': 'Hoje',
  'calendar.prev_month': 'Mês anterior',
  'calendar.next_month': 'Próximo mês',
  'calendar.prev_year': 'Ano anterior',
  'calendar.next_year': 'Próximo ano',

  'animal.access': 'Abrir animal',
  'common.options': 'Opções',
} as const;

export type MessageKey = keyof typeof ptBR;
